export default __webpack_public_path__ + "static/media/strasbourg16.cfe20899.jpg";